export default "__VITE_ASSET__rgbALrlg__"